/**
 * Two campaigns are live: the series details page one (SHO-758) and the new
 * player one (SHO-815). Add the next one as another row here and
 * `useAmplitudeExperiment` fetches its flag too.
 */
export type ABTestCampaignId = string;

export type ABTestVariant = {
  name: string;
  value: string;
};

export type ABTestCampaign = {
  id: ABTestCampaignId;
  name: string;
  variants: Array<ABTestVariant>;
  /**
   * When the SDK reports `[Experiment] Exposure`. `automatic`: on the boot
   * read, through `experiment.variant()`, so every visitor counts as exposed.
   * `manual`: never on its own — the flag is read through `experiment.all()`
   * and only `trackExperimentExposure` reports it, from the one place where
   * the variant decides something.
   */
  exposure: "automatic" | "manual";
};

export const SERIES_DETAILS_CAMPAIGN_ID = "sw_ab_series_details_page";
export const NEW_PLAYER_CAMPAIGN_ID = "sw_ab_web_player";

// The Experiment SDK's own exposure event, as `trackExperimentExposure`
// mirrors it into the test capture buffer. Here rather than next to the
// tracking event names: it is not one of ours, and this module is the
// side-effect-free one the e2e specs can import.
export const EXPERIMENT_EXPOSURE_EVENT = "[Experiment] Exposure";

export const AB_TEST_CAMPAIGNS_DATA: ReadonlyArray<ABTestCampaign> = [
  {
    id: SERIES_DETAILS_CAMPAIGN_ID,
    name: "Series details page",
    variants: [
      { name: "control", value: "0" },
      { name: "treatment", value: "1" },
    ],
    // What the test measures is going through a page before starting a
    // series, so the exposure is the catalog click that decides between the
    // page and the player (`SeriesLink`), not the app load.
    exposure: "manual",
  },
  {
    id: NEW_PLAYER_CAMPAIGN_ID,
    name: "Web player",
    variants: [
      { name: "control", value: "0" },
      { name: "treatment", value: "1" },
    ],
    // The whole session is the unit under test (watch completion, paywall
    // reach), so a visitor is exposed at session start, player opened or not.
    exposure: "automatic",
  },
];

export const EXPERIMENT_IDS = AB_TEST_CAMPAIGNS_DATA.map((c) => c.id);
